import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { Provider } from 'react-redux';
import {store} from './store';
const root = ReactDOM.createRoot(document.getElementById('root'))
// pk_test_51PyDsJBAX2F2eU1KbieCrKDdTaHKOjOGLp0R3iuAFsapai4iwMbJTcK7Ijh9TQqbpdpih0ipTIIggXR1OWU6MwhB001Cb77z0I
// pk_live_51PyDsJBAX2F2eU1KlLyFRRg8qEgij0OHgopTJ2Zc4nYKrhSnkX0wclEKg7iq1W5ZhMxOGDRjC0fHnqMlxUWFcJuE00b0OlWFI2
const stripePromise = loadStripe(
  'pk_live_51PyDsJBAX2F2eU1KlLyFRRg8qEgij0OHgopTJ2Zc4nYKrhSnkX0wclEKg7iq1W5ZhMxOGDRjC0fHnqMlxUWFcJuE00b0OlWFI2'
)
root.render(
  <React.StrictMode>
     <Provider store={store}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
